import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { normalizeLanguage, SUPPORTED_LANGUAGES, type UiLanguage } from '../i18n';

export function LanguageSwitcher({ onChange }: { onChange?: (lang: UiLanguage) => void }) {
  const { t, i18n } = useTranslation();
  const id = useId();
  const current = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);

  return (
    <div className="lang-switcher">
      <label htmlFor={id} className="sr-only">
        {t('lang.label')}
      </label>
      <select
        id={id}
        value={current}
        onChange={(e) => {
          const lang = e.target.value as UiLanguage;
          void i18n.changeLanguage(lang);
          onChange?.(lang);
        }}
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <option key={lng} value={lng} lang={lng}>
            {t(`lang.${lng}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
